import { useCallback, useMemo } from 'react';

import { useHistory } from 'react-router-dom';

import { createOrderDetailsReturnPathname } from '../routing';
import { NewReturnFulfillmentId, NewEnhancedReturnIdPrefix } from './use-pending-return';

export const useReturnNavigation = () => {
  const history = useHistory();

  const createPath = useCallback(
    (salesOrderId, returnId, storeSupportsEnhancedReturns = false, injectSearchParams = {}) => {
      const currentPathname = history.location.pathname;
      const currentSearchParams = Object.fromEntries(new URLSearchParams(history.location.search));
      const newSearchString = new URLSearchParams({ ...currentSearchParams, ...injectSearchParams }).toString();
      const newPathname = createOrderDetailsReturnPathname(currentPathname, salesOrderId, returnId, storeSupportsEnhancedReturns);

      return `${newPathname}${newSearchString ? `?${newSearchString}` : ''}`;
    },
    [history],
  );

  const createPendingEnhancedReturnPlaceholderId = useCallback((returnId) => {
    return returnId ? `${NewEnhancedReturnIdPrefix}${returnId}` : NewReturnFulfillmentId;
  }, []);

  const navigateToReturn = useCallback(
    (salesOrderId, returnId, storeSupportsEnhancedReturns = false, injectSearchParams = {}) => {
      history.push(createPath(salesOrderId, returnId, storeSupportsEnhancedReturns, injectSearchParams));
    },
    [history, createPath],
  );

  return useMemo(() => {
    return {
      createPath,
      navigateToReturn,
      createPendingEnhancedReturnPlaceholderId,
    };
  }, [createPath, navigateToReturn, createPendingEnhancedReturnPlaceholderId]);
};
